function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useRef } from 'react';
import { useSearchBox } from 'react-instantsearch-core';
import Autosuggest from 'react-autosuggest';
import { useHits } from 'react-instantsearch';
import { useTranslation } from 'react-i18next';
import useAutoSuggest from '../../hooks/useAutoSuggest';
import { DEFAULT_TEXT } from '../../config/constants';
import './style.scss';
const SearchAutosuggest = props => {
  const {
    value,
    setValue
  } = useAutoSuggest();
  const {
    t
  } = useTranslation();
  const {
    query,
    refine
  } = useSearchBox();
  const {
    hits
  } = useHits();
  const {
    autoCompleteDebounce = 0,
    placeholder = ''
  } = props;
  const timeoutRef = useRef();
  const assistiveHintText = t(['searchkit.autosuggest.assistive_hint', DEFAULT_TEXT.AUTOSUGGEST.ASSISTIVE_HINT]);
  const inputProps = {
    placeholder,
    value,
    onChange: (event, _ref) => {
      let {
        newValue
      } = _ref;
      event.persist();
      setValue(newValue);
    },
    'aria-describedby': 'autosuggest-assistive-hint'
  };
  useEffect(() => {
    if (query === '') {
      setValue('');
    }
  }, [query]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Autosuggest, _extends({}, props, {
    suggestions: hits
    // Explicitly put focusInputOnSuggestionClick on false.
    // Because it doesn't work together properly with the
    // renderInputComponent prop.
    ,
    focusInputOnSuggestionClick: false,
    onSuggestionsFetchRequested: _ref2 => {
      let {
        value: newValue
      } = _ref2;
      if (autoCompleteDebounce === 0) {
        refine(newValue);
      } else {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
          refine(newValue);
        }, autoCompleteDebounce);
      }
    },
    inputProps: inputProps
  })), /*#__PURE__*/React.createElement("div", {
    id: "autosuggest-assistive-hint"
  }, assistiveHintText));
};
export default SearchAutosuggest;